/**
 * Recruiting Status Constants
 * These statuses are used throughout the recruiting module to track candidate progress
 */
export const RECRUITING_STATUS = {
  NOT_INTERESTED: 'Not Interested',
  NOT_QUALIFIED: 'Not Qualified',
  REACHED: 'Reached',
  LM1: 'LM1',
  LM2: 'LM2',
  LM3: 'LM3',
  LM4: 'LM4',
  LM5: 'LM5',
  LM6: 'LM6',
  BLOCKED: 'Blocked',
  CANCELLED_INTERVIEW: 'Cancelled Interview',
};

/**
 * Statuses that indicate a candidate should be excluded from outreach
 */
export const EXCLUDED_STATUSES = [
  RECRUITING_STATUS.NOT_QUALIFIED,
  RECRUITING_STATUS.NOT_INTERESTED,
];
